/**
 * +field: the offline rate the Hearthkeeper explains (docs/design/zones.md "Offline"): full Auto
 * rate for OFFLINE_FULL_H hours, then the rate halves every OFFLINE_HALF_H hours, capped at
 * OFFLINE_CAP_H hours. Display only in Phase 1 (Phase 2 runs it on the server's clock). Pure.
 */
export const OFFLINE_FULL_H = 2;
export const OFFLINE_HALF_H = 4;
export const OFFLINE_CAP_H = 24;

/** Rate (0..1 of Auto's) at `hours` after logging off. */
export function offlineRate(hours: number): number {
  if (hours < 0 || hours >= OFFLINE_CAP_H) return 0;
  return hours <= OFFLINE_FULL_H ? 1 : 0.5 ** ((hours - OFFLINE_FULL_H) / OFFLINE_HALF_H);
}

/** Hours of full-rate Auto that `hours` away are worth (the integral of offlineRate). */
export function offlineAutoHours(hours: number): number {
  const h = Math.max(0, Math.min(OFFLINE_CAP_H, hours));
  if (h <= OFFLINE_FULL_H) return h;
  const t = h - OFFLINE_FULL_H;
  return OFFLINE_FULL_H + (OFFLINE_HALF_H / Math.LN2) * (1 - 0.5 ** (t / OFFLINE_HALF_H));
}
